export default __webpack_public_path__ + "static/background-09b0c97a1e4b47c2f7458c8bd1e0fe68.svg";